import React from 'react';

function MarketingBannerSkeleton() {
  return (
    <section className="marketing-banner-skeleton animate-pulse bg-skeleton w-full max-w-full rounded-[24px] aspect-[1.02/1] lg:aspect-[1.8/1]" />
  );
}

export default MarketingBannerSkeleton;
